import { useState, useEffect } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserPosition,
  getMyPosition,
} from "../../../features/position/positionSlice";
import CustomButton from "../../share/customButton";
import TedDownArrowGrayIcon from "../../icons/Navbar/TedDownArrowGray";

const SelectPosition = () => {
  const [value, setValue] = useState("");
  const myPositions = useSelector(getMyPosition);

  const positionStatus = useSelector(
    (state) => (state as any).positions.status
  );
  const dispatch = useDispatch<any>();

  useEffect(() => {
    dispatch(fetchUserPosition());

    //console.log("mps", myPositions);

    if (myPositions.positions.name !== undefined) {
      const t =
        myPositions.positions.name + " " + myPositions.positions.company.name;
      setValue(t);
    }
  }, []);
  useEffect(() => {
    console.log("mp", myPositions);

    if (myPositions.positions.name !== undefined) {
      const t =
        myPositions.positions.name + " " + myPositions.positions.company.name;
      setValue(t);
    } else {
      setValue("بدون سمت");
    }
  }, [myPositions]);

  return (
    <>
      {/* <Autocomplete
        disabled
        className="mx-2"
        dir="rtl"
        value={null}
        style={{ textAlign: "right" }}
        disablePortal
        id="combo-box-demo"
        noOptionsText=""
        onChange={(event: any, newValue: any) => {
          setValue(newValue);
        }}
        renderInput={(params) => (
          <TextField
            sx={{
              width: 200,
              "& label": {
                left: "unset",
                right: "1.75rem",
                transformOrigin: "right",
                fontSize: "0.85rem",
              },
              "& legend": {
                textAlign: "right",
                fontSize: "0.85rem",
              },
              paddingRight: "0px",
            }}
            {...params}
            label={value}
          />
        )}
        options={[]}
      /> */}

      <CustomButton
        style={{ border: "0px", width: "177px", height: "40px" }}
        LeftIcon={TedDownArrowGrayIcon}
        LeftIconEnabled
        hasTitle
      >
        {value}
      </CustomButton>
    </>
  );
};
export default SelectPosition;
